import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import {
  AddressForm, AddressInformationForm, BaseForm, DeliveryAddressForm, STATES_BY_ABBREVIATION, SmartyStreetService,
} from '@lc/core';
import { Observable } from 'rxjs';
import { catchError, debounceTime, switchMap } from 'rxjs/operators';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { E2eIdDirective } from '@lc/ui/lib/core';
import { TextboxComponent } from '../../../inputs/textbox/textbox.component';
import { AutocompleteComponent } from '../../../inputs/autocomplete/autocomplete.component';
import { ResponsiveClassDirective } from '../../../core/directives/responsive-class.directive';
import { DropdownComponent } from '../../../inputs/dropdown/dropdown.component';
import { PhoneNumberComponent } from '../../../inputs/phone-number/phone-number.component';

@Component({
  selector: 'lc-address-details-form',
  templateUrl: './address-details-form.component.html',
  styleUrls: ['./address-details-form.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TextboxComponent,
    AutocompleteComponent,
    ResponsiveClassDirective,
    DropdownComponent,
    PhoneNumberComponent,
    AsyncPipe,
    E2eIdDirective,
  ],
})
export class AddressDetailsFormComponent implements OnChanges {
  smartyStreetService? = inject(SmartyStreetService);

  @Input() formGroup: AddressForm | DeliveryAddressForm | AddressInformationForm;
  @Input() isPrintProduct: boolean = false;

  addressOptions$: Observable<any[]>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.formGroup && this.formGroup) {
      this.addressOptions$ = (this.formGroup instanceof AddressForm
        ? this.formGroup.getControl('streetAddress1')
        : (this.formGroup.getControl('address') as BaseForm).getControl('streetAddress1'))
        .valueChanges
        .pipe(
          debounceTime(200),
          switchMap(async (data) => {
            if (this.smartyStreetService.isSearchable(data)) {
              console.log(`SmartStreety API -> ${data} Requested`);
              return await this.smartyStreetService.getAddressSuggestions(data);
            }

            return [];
          }),
          catchError((error) => {
            console.log(`AddressDetailsFormComponent  Smart street error = ${error} `);
            return [];
          }),
        );
    }
  }

  /**
   * Updates entire form with returned response from smartyStreet API
   * @param event
   */
  updateAddressFields(event) {
    const address = {
      city: event.city ? event.city : '',
      postalCode: event.postalCode ? event.postalCode : '',
      state: event.state ? event.state : '',
      streetAddress1: event.streetAddress1 ? event.streetAddress1 : '',
      streetAddress2: event.streetAddress2 ? event.streetAddress2 : '',
    };

    this.formGroup instanceof AddressForm
      ? this.formGroup.setValue(address)
      : this.formGroup.getControl('address').setValue(address);
  }

  getControl(controlName: string) {
    return this.formGroup instanceof AddressForm
      ? this.formGroup.get(controlName)
      : this.formGroup.getControl('address').get(controlName);
  }

  getStates() {
    return STATES_BY_ABBREVIATION;
  }
}
